/* eslint-disable @typescript-eslint/no-explicit-any, no-console */
(function () {
    var _a;
    if (typeof window !== 'undefined') {
        //TODO: WHAT IF MULTIPLE VERSIONS OF FERRIS ARE LOADED ON A PAGE; E.G. APP AND NAV
        window.Ferris = window.Ferris || Object.freeze({
            Core: Object.freeze({
                version: 'v1.2.27'
            }),
            React: Object.freeze({
                version: 'v1.7.38'
            })
        });
        if (/[^(test)]/.test((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.NODE_ENV)) {
            console.groupCollapsed('[FERRIS]');
            console.log('Ferris Core', window.Ferris.Core.version);
            console.log('Ferris React', window.Ferris.React.version);
            console.groupEnd();
        }
    }
})();
/* eslint-enable @typescript-eslint/no-explicit-any, no-console */
